export const getCtaColorClasses = (style, colorUnderTheButton) => {
    // use the same defualt as getBackgroundColor
    colorUnderTheButton = colorUnderTheButton || 'portsmouthNavy';
    switch (style) {
        case 'secondary':
            return getSecondaryColorClasses(colorUnderTheButton);
        case 'primary':
        default:
            return getPrimaryColorClasses(colorUnderTheButton);
    }
};
export const getPrimaryColorClasses = (colorUnderTheButton) => {
    switch (colorUnderTheButton) {
        case 'portsmouthNavySuperdark':
        case 'portsmouthNavy':
            return 'bg-secondary-yorkShireCyan hover:bg-primary-bregRiverBlue text-primary-portsmouthNavy hover:text-white border-1 hover:border-1 border-transparent';
        default:
            return 'bg-primary-portsmouthNavy hover:bg-primary-bregRiverBlue text-white hover:text-white border-1 hover:border-1 border-transparent';
    }
};
export const getSecondaryColorClasses = (bgColor) => {
    switch (bgColor) {
        case 'portsmouthNavy':
            return 'bg-transparent hover:bg-secondary-yorkShireCyan text-secondary-yorkShireCyan hover:text-primary-portsmouthNavy border-1 hover:border-1 border-secondary-yorkShireCyan hover:border-transparent';
        default:
            return 'bg-transparent hover:bg-primary-portsmouthNavy text-primary-portsmouthNavy hover:text-white border-1 hover:border-1 border-primary-portsmouthNavy hover:border-transparent';
    }
};
